// Mock data for Joana Trigo Pessoa Psychology Website

export const psychologistInfo = {
  name: "Joana Trigo Pessoa",
  title: "Psicóloga Clínica",
  bio: "Licenciada em Psicologia e Mestre em Psicologia dos RH, do Trabalho e das Organizações pela Faculdade de Psicologia da Universidade de Lisboa. Em 2023 fiz uma formação em Hipnoterapia Clínica pela Transpersonal International. Em 2024 iniciei a Especialização Avançada em Psicoterapia pelo ISPA e em 2026 uma Especialização em Psicologia Clínica e da Saúde no CRIAP. Sou membro da Ordem dos Psicólogos Portugueses (OPP).",
  email: "joanatrigopessoa@gmail.com",
  instagram: "joanatrigopessoa_psicologa",
  consultationType: "Consultas on-line",
  bookingLink: "https://forms.cloud.microsoft/r/BcA7NM2XSj",
  heroImage: "https://customer-assets.emergentagent.com/job_mental-health-pt/artifacts/3iqe3nj7_C7583888-6510-468E-B657-0A5BF6D58A7B.jpeg",
  aboutImage: "https://customer-assets.emergentagent.com/job_mental-health-pt/artifacts/jm9thhti_1596110C-C6EE-445F-846B-808228FD039D.jpeg",
  profileImage2: "https://customer-assets.emergentagent.com/job_mental-health-pt/artifacts/3iqe3nj7_C7583888-6510-468E-B657-0A5BF6D58A7B.jpeg",
  servicesImage: "https://images.unsplash.com/photo-1637245048732-adf1a547835e",
  testimonialsImage: "https://images.unsplash.com/photo-1579208575657-c595a05383b7",
  opp: "Membro da Ordem dos Psicólogos Portugueses",
  university: "Faculdade de Psicologia da Universidade de Lisboa"
};

export const services = [
  {
    id: 1,
    title: "Psicologia Clínica",
    description: "Acompanhamento psicológico individualizado para jovens adultos e adultos, focado no bem-estar mental e emocional.",
    icon: "Brain"
  },
  {
    id: 2,
    title: "Psicoterapia",
    description: "Processo terapêutico profundo que visa a compreensão e transformação de padrões emocionais e comportamentais.",
    icon: "Heart"
  },
  {
    id: 3,
    title: "Hipnoterapia",
    description: "Técnica terapêutica complementar que utiliza o estado de hipnose para acesso ao inconsciente e mudança profunda.",
    icon: "Sparkles"
  }
];

export const howItWorksSteps = [
  {
    id: 1,
    step: "01",
    title: "Primeiro Contacto",
    description: "Entre em contacto através do formulário ou email para agendar a sua primeira consulta."
  },
  {
    id: 2,
    step: "02",
    title: "Consulta Inicial",
    description: "Na primeira sessão, vamos conhecer-nos e compreender as suas necessidades e objetivos terapêuticos."
  },
  {
    id: 3,
    step: "03",
    title: "Plano Personalizado",
    description: "Desenvolvimento de um plano terapêutico adaptado às suas necessidades específicas."
  },
  {
    id: 4,
    step: "04",
    title: "Acompanhamento",
    description: "Sessões regulares de acompanhamento psicológico, com monitorização contínua do seu progresso."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Ana M.",
    text: "A Dra. Joana ajudou-me a ultrapassar um período muito difícil da minha vida. A sua abordagem empática e profissional fez toda a diferença.",
    rating: 5
  },
  {
    id: 2,
    name: "Ricardo S.",
    text: "Recomendo vivamente! As sessões de hipnoterapia foram transformadoras. Sinto-me muito mais confiante e em paz comigo mesmo.",
    rating: 5
  },
  {
    id: 3,
    name: "Mariana P.",
    text: "Profissional extremamente competente e acolhedora. Criou um espaço seguro onde me sinto à vontade para partilhar.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "Como funcionam as consultas online?",
    answer: "As consultas online são realizadas através de videochamada numa plataforma segura e confidencial. Apenas necessita de um dispositivo com câmara e ligação à internet."
  },
  {
    id: 2,
    question: "Qual a duração de uma sessão?",
    answer: "Cada sessão tem a duração de aproximadamente 50 minutos. A frequência das sessões é definida em conjunto, de acordo com as suas necessidades."
  },
  {
    id: 3,
    question: "A hipnoterapia é segura?",
    answer: "Sim, a hipnoterapia clínica é uma técnica segura e cientificamente validada. É sempre realizada num contexto terapêutico profissional e ético."
  },
  {
    id: 4,
    question: "Preciso de ter algum diagnóstico prévio?",
    answer: "Não é necessário ter um diagnóstico prévio. Na primeira consulta faremos uma avaliação inicial para compreender a sua situação."
  },
  {
    id: 5,
    question: "Como posso marcar uma consulta?",
    answer: "Pode marcar através do formulário de contacto no site, por email (joanatrigopessoa@gmail.com) ou através do Instagram."
  },
  {
    id: 6,
    question: "Qual o valor das consultas?",
    answer: "O valor das consultas varia de acordo com o tipo de acompanhamento. Entre em contacto para mais informações sobre valores e disponibilidade."
  }
];

// Mock function to simulate booking appointment
export const mockBookAppointment = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Mock Appointment Booked:", formData);
      localStorage.setItem('lastBooking', JSON.stringify({
        ...formData,
        bookingDate: new Date().toISOString(),
        status: 'pending'
      }));
      resolve({
        success: true,
        message: "Pedido de marcação recebido! Entraremos em contacto brevemente.",
        bookingId: `BK${Date.now()}`
      });
    }, 1000);
  });
};
